import { DATE_FORMATS, formatDate } from '@amelio/ui-library';
import { useTranslation } from 'react-i18next';

interface HandoutFooterProps {
    generatedDate: string;
    isSummaryPage?: boolean;
}

export const HandoutFooter = ({ generatedDate, isSummaryPage }: HandoutFooterProps) => {
    const { t, i18n } = useTranslation();
    const parsedDate = new Date(generatedDate);
    const formattedDate = Number.isNaN(parsedDate.getTime())
        ? generatedDate
        : formatDate({
              date: parsedDate,
              language: i18n.language,
              format: DATE_FORMATS.DISPLAY_DATE,
          });
    const generatedLabel = t('postReviewPrepareMeeting.handout.documentGenerated', {
        date: '__DATE__',
    });
    const [generatedPrefix, generatedSuffix] = generatedLabel.split('__DATE__');

    return (
        <div className={'px-8 py-2'}>
            <p
                className={`text-caption! border-t border-gray-200 py-2 text-gray-500 ${
                    isSummaryPage ? '' : 'text-right'
                }`}
            >
                {generatedPrefix}
                <span className={'font-bold text-gray-900'}>{formattedDate}</span>
                {generatedSuffix}
            </p>
        </div>
    );
};
